/**
 * Ultimately VV items should be using .5625 (16/9),
 * but we consider anything less than a square AR (1:1) vertical
 */
export const VERTICAL_ASPECT_RATIO_THRESHOLD = 1;
/**
 * Default aspect ratio for items that don't have one specified (16:9).
 */
export const DEFAULT_ASPECT_RATIO = 1.77777;
